import {PriceList}    from "../../../shared-gen/Model/PriceLists/PriceList";
import {getDefaultID} from "../../core";
import { EntityType } from "../../../shared-gen/Model/Utils/EntityType";
import { ExtendedPriceList } from "../../../shared-gen/Model/PriceLists/ExtendedPriceList";
import { PriceListFun } from "./price-list.fun";

export class ExtendedPriceListFun {

	static createNew(providerID: string): ExtendedPriceList {
		return {
			DefaultPriceList: PriceListFun.createNew(providerID),
			AdditionalPriceLists: []
		};
	}

}
